'use client'

import { articleSizeState } from '@store/articleSize'
import { theme } from '@ui/style'
import color from '@ui/style/color.theme'
import { pretendard } from '@ui/style/muiTheme'
import typo from '@ui/style/typo.theme'
import pxToRem from '@utils/pxToRem'
import { useRecoilState } from 'recoil'

export const ParticleCSS = () => {
	const [state] = useRecoilState(articleSizeState)
	const textSize = state.articleSize?.toLowerCase() as 'm' | 'l' | 'xl'

	const textStyle = typo.article.body[textSize || 'm']

	const quotationSizes = {
		mo: {
			m: {
				fontSize: pxToRem(20),
				lineHeight: pxToRem(32),
				letterSpacing: '-0.08px',
			},
			l: {
				fontSize: pxToRem(22),
				lineHeight: pxToRem(34),
				letterSpacing: '-0.088px',
			},
			xl: {
				fontSize: pxToRem(24),
				lineHeight: pxToRem(36),
				letterSpacing: '-0.096px',
			},
		},
		pc: {
			m: {
				fontSize: pxToRem(22),
				lineHeight: pxToRem(36),
				letterSpacing: '-0.088px',
			},
			l: {
				fontSize: pxToRem(24),
				lineHeight: pxToRem(38),
				letterSpacing: '-0.096px',
			},
			xl: {
				fontSize: pxToRem(26),
				lineHeight: pxToRem(40),
				letterSpacing: '-0.104px',
			},
		},
	}

	const particleTextSizes = {
		mo: {
			m: {
				fontSize: pxToRem(18),
				lineHeight: pxToRem(30),
				letterSpacing: '-0.072px',
			},
			l: {
				fontSize: pxToRem(20),
				lineHeight: pxToRem(32),
				letterSpacing: '-0.08px',
			},
			xl: {
				fontSize: pxToRem(22),
				lineHeight: pxToRem(34),
				letterSpacing: '-0.088px',
			},
		},
		pc: {
			m: {
				fontSize: pxToRem(20),
				lineHeight: pxToRem(34),
				letterSpacing: '-0.08px',
			},
			l: {
				fontSize: pxToRem(22),
				lineHeight: pxToRem(36),
				letterSpacing: '-0.088px',
			},
			xl: {
				fontSize: pxToRem(24),
				lineHeight: pxToRem(38),
				letterSpacing: '-0.096px',
			},
		},
	}

	return {
		fontFamily: pretendard.style.fontFamily,
		color: color.colBlack,
		fontWeight: 400,
		letterSpacing: 0,
		lineHeight: 'normal',
		'& img': {
			maxWidth: '100%',
		},
		'& *': {
			fontFamily: `inherit!important`,
		},
		// 관련 기사
		// 이미지 있는 케이스 추가 필요
		'.related_docs': {
			fontFamily: pretendard.style.fontFamily,
			color: color.colBlack,
			padding: pxToRem(13),
			paddingTop: pxToRem(11),
			border: `1px solid ${color.colGray3}`,
			display: 'flex',
			flexDirection: 'column',
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
			'&>*:not(:first-child)': {
				marginTop: pxToRem(11),
			},
			'&>*.docs_upper + *': {
				marginTop: pxToRem(12),
			},
			'.docs_upper': {
				paddingBottom: pxToRem(9),
				borderBottom: `1px solid ${color.colGray3}`,
				strong: {
					fontSize: pxToRem(14),
					lineHeight: pxToRem(20),
					fontWeight: 600,
				},
			},
			'.jch_link': {
				display: 'flex',
				alignItems: 'center',
				'&>*:not(:first-child)': {
					marginLeft: pxToRem(16),
				},
			},
			'.docs_box': {
				display: 'flex',
				flexDirection: 'column',
				minHeight: pxToRem(68),
				justifyContent: 'center',
				'& + .docs_box': {
					paddingTop: pxToRem(12),
					borderTop: `1px solid ${color.colGray3}`,
				},
				'&>*:not(:first-child)': {
					marginTop: pxToRem(12),
				},
				'.thumb': {
					width: pxToRem(120),
					height: pxToRem(68),
					minWidth: 0,
					flexShrink: 0,
					background: '#eee',
					img: {
						width: '100%',
						height: '100%',
						objectFit: 'contain',
					},
				},
				'.inner': {
					display: 'flex',
					flexDirection: 'column',
					'&>*:not(:first-child)': {
						marginTop: pxToRem(8),
					},
					h4: {
						display: '-webkit-box',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						WebkitBoxOrient: 'vertical',
						WebkitLineClamp: 2,
						fontSize: pxToRem(15),
						lineHeight: pxToRem(22),
						fontWeight: 700,
						[theme.breakpoints.up('md')]: {
							fontSize: pxToRem(16),
							lineHeight: pxToRem(24),
						},
					},
					'.auth_info': {
						fontSize: pxToRem(14),
						lineHeight: pxToRem(16),
						fontWeight: 500,
						color: color.colGray5,
					},
				},
			},
		},

		// 이미지, gif 이미지, 그래픽 이미지, 데이터 입력(표)
		'.ab_photo': {
			padding: '0!important',
			maxWidth: '100%',
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
			'.image img': {
				maxWidth: '100%',
			},
			'.caption': {
				fontFamily: pretendard.style.fontFamily,
				fontSize: pxToRem(14),
				lineHeight: pxToRem(22),
				fontWeight: 500,
				color: color.colGray5,
				marginTop: pxToRem(10),
				letterSpacing: 0,
			},
		},
		// 일반 삽입 이미지?
		'.jtbc_img': {
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
		},

		// 인용구
		'.tag_quotation, .ab_quotation, .module_blockquote, .module_blockquote.v2': {
			position: 'relative',
			textAlign: 'center',
			fontWeight: 700,
			margin: {
				xs: `${pxToRem(16)} 0 ${pxToRem(56)}`,
				md: `${pxToRem(16)} 0 ${pxToRem(64)}`,
			},
			borderTop: `1px solid ${color.colBlack}`,
			borderBottom: `1px solid ${color.colBlack}`,
			padding: `${pxToRem(28)} ${pxToRem(20)}`,
			...quotationSizes.mo[textSize],
			[theme.breakpoints.up('md')]: {
				padding: `${pxToRem(32)} ${pxToRem(24)}`,
				...quotationSizes.pc[textSize],
			},
			'&::after': {
				content: '""',
				width: pxToRem(34),
				height: pxToRem(34),
				background: 'url(/images/icon/iconQuote.svg) no-repeat center / contain',
				position: 'absolute',
				top: 0,
				left: '50%',
				marginLeft: pxToRem(-34 / 2),
				marginTop: pxToRem(-34 / 2),
				zIndex: 1,
			},
			'&::before': {
				content: '""',
				width: pxToRem(58),
				height: '3px',
				background: color.colWhite,
				position: 'absolute',
				top: '-1px',
				left: '50%',
				marginLeft: pxToRem(-58 / 2),
				zIndex: 0,
			},
			'span, p': {
				fontWeight: 700,
				padding: 0,
				color: color.colBlack,
				fontSize: 'inherit',
				lineHeight: 'inherit',
				letterSpacing: 'inherit',
				'.icon': {
					display: 'none',
				},
				'&::before, &::after': {
					display: 'none',
				},
			},
		},

		// 강조문
		'.ab_emphasis': {
			margin: 0,
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
			fontWeight: 600,
			background: color.colGray1,
			border: `1px solid ${color.colGray3}`,
			'&::before, &::after': {
				display: 'none',
			},
			'&_content, &>p': {
				display: 'inline-block',
				padding: `${pxToRem(28)} ${pxToRem(32)}`,
				fontWeight: 600,
				...particleTextSizes.mo[textSize],
				[theme.breakpoints.up('md')]: {
					padding: `${pxToRem(28)} ${pxToRem(40)}`,
					...particleTextSizes.pc[textSize],
				},
			},
		},

		// 인터뷰
		'.tag_interview': {
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
			'.tag_question, .tag_answer': {
				margin: 0,
				minHeight: 0,
				paddingLeft: pxToRem(54),
				fontWeight: 700,
				...particleTextSizes.mo[textSize],
				[theme.breakpoints.up('md')]: {
					paddingLeft: pxToRem(58),
					...particleTextSizes.pc[textSize],
				},
				span: {
					fontWeight: 700,
					...particleTextSizes.mo[textSize],
					[theme.breakpoints.up('md')]: {
						...particleTextSizes.pc[textSize],
					},
				},
				'&::after': {
					top: 0,
					width: pxToRem(42),
					height: pxToRem(42),
					transform: 'initial',
				},
			},
			'.tag_question': {
				color: color.colMintBlue,
				span: {
					color: color.colMintBlue,
				},
				'&::after': {
					background: 'url(/images/icon/iconInterviewQ.svg) no-repeat center / contain',
				},
			},
			'.tag_answer': {
				color: color.colBlack,
				span: {
					color: color.colBlack,
				},
				'&::after': {
					background: 'url(/images/icon/iconInterviewA.svg) no-repeat center / contain',
				},
			},
		},

		// 중간 제목
		'.ab_sub_heading': {
			margin: 0,
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
			padding: `${pxToRem(14)} 0`,
			borderTop: `2px solid ${color.colBlack}`,
			borderBottom: `1px solid ${color.colGray3}`,
			'.ab_sub_headingline h2': {
				color: `${color.colBlack}!important`,
				fontWeight: 700,
				...particleTextSizes.mo[textSize],
				[theme.breakpoints.up('md')]: {
					...particleTextSizes.pc[textSize],
				},
			},
		},

		// 가로선
		'.hline1, hr': {
			margin: 0,
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
			padding: 0,
			border: 0,
			height: 0,
			borderTop: `1px solid ${color.colBlack}`,
		},

		// 비디오
		'.videoPlayerContainer': {
			margin: 0,
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
		},

		// embeded
		'.fr-embedly': {
			margin: 0,
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
		},

		// facebook post
		'.fb-post': {
			margin: 0,
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
		},

		// 차트
		'.ab_chart_dynamic': {
			margin: 0,
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
		},

		// 스크립트
		'.blue_script_box, .black_script_box': {
			marginBottom: pxToRem(16),
			padding: `${pxToRem(16)} ${pxToRem(16)} ${pxToRem(14)} ${pxToRem(16)}`,
			'&>*:not(:first-child)': {
				marginTop: pxToRem(16),
			},
			'.script_box_title': {
				display: 'inline-block',
				borderRadius: pxToRem(4),
				padding: `${pxToRem(6)} ${pxToRem(16)}`,
				fontSize: pxToRem(16),
				lineHeight: pxToRem(22),
				letterSpacing: '-0.064px',
				fontWeight: 700,
				color: color.colWhite,
			},
			'.script_box_content': {
				fontSize: pxToRem(18),
				lineHeight: pxToRem(32),
				letterSpacing: '-0.072px',
				fontWeight: 500,
				color: color.colBlack,
			},
		},
		'.blue_script_box': {
			background: '#F2F9FF',
			'.script_box_title': {
				background: color.colPointBlue,
			},
		},
		'.black_script_box': {
			background: '#F8F8F8',
			'.script_box_title': {
				background: color.colBlack,
			},
		},

		// 부스러기 제거
		'.dim': {
			display: 'none!important',
		},

		// 이미지 박스
		// 이미지 박스 내에서 파티클들이 별도의 마진을 가져야 함
		'.ab_box_article': {
			padding: 0,
			marginBottom: {
				xs: pxToRem(40),
				md: pxToRem(48),
			},
			'.ab_box_title': {
				margin: 0,
				color: color.colBlack,
				...textStyle,
			},
			'.ab_box_titleline': {
				...textStyle,
				fontWeight: 500,
				paddingBottom: {
					xs: pxToRem(24),
					md: pxToRem(32),
				},
			},
			'.ab_box_titleline:empty': {
				paddingBottom: 0,
			},
			'.ab_box_bullet': {
				display: 'none!important',
			},
			'.ab_box_inner': {
				border: `1px solid ${color.colBlack}`,
				padding: pxToRem(16),
				[theme.breakpoints.up('md')]: {
					padding: pxToRem(24),
				},
				'.related_docs, .ab_photo, .tag_quotation, .ab_quotation, .module_blockquote, .module_blockquote.v2, .ab_emphasis, .tag_interview, .ab_sub_heading, .hline1, hr, .videoPlayerContainer, .fr-embedly, .fb-post, .blue_script_box, .black_script_box':
					{
						marginBottom: 0,
						marginTop: {
							xs: pxToRem(24),
							md: pxToRem(32),
						},
					},
				'&>*:first-child': {
					marginTop: 0,
					'.ab_box_titleline': {
						paddingBottom: 0,
					},
				},
			},
			'.ab_box_content': {
				marginTop: {
					xs: pxToRem(-24),
					md: pxToRem(-32),
				},
				'&>span.MuiTypography-root': {
					display: 'block',
					marginTop: {
						xs: pxToRem(24),
						md: pxToRem(32),
					},
				},
				'&>br': {
					display: 'none',
				},
				'&>*:first-child': {
					marginTop: {
						xs: pxToRem(24),
						md: pxToRem(32),
					},
					display: 'block',
				},
				'figure + br': {
					display: 'none',
				},
			},
			'figure figcaption': {
				fontFamily: pretendard.style.fontFamily,
				color: color.colGray5,
				fontWeight: 500,
				fontSize: pxToRem(14),
				lineHeight: pxToRem(22),
			},
		},
	}
}
